import React, { useEffect, useState } from "react";
import { HandCoins, Loader2, LogOut } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { KIND_LABEL, statementExcel, statementPdf } from "@/lib/payoutExport";
import { Cards, RangeBar, StatementTable, defaultRange } from "@/components/payout/PayoutBits";
import { DownloadMenu } from "@/components/payout/DownloadMenu";
import { RatesList } from "@/components/payout/PersonPanel";

export default function MyPayout() {
  const { user, logout } = useAuth();
  const [range, setRange] = useState(defaultRange);
  const [st, setSt] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    let alive = true;
    setSt(null);
    api.get("/payouts/me", { params: { from_date: range.from, to_date: range.to } })
      .then(({ data }) => { if (alive) { setSt(data); setErr(""); } }).catch((e) => alive && setErr(formatApiError(e)));
    return () => { alive = false; };
  }, [range.from, range.to]);
  return (
    <div className="min-h-screen bg-[#F8F8F3]">
      <header className="border-b border-[#EDEDE5] bg-white sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-4 py-3 flex items-center gap-3">
          <HandCoins className="w-5 h-5 text-[#385C4B]" />
          <div className="min-w-0">
            <h1 className="font-semibold text-lg tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>My Payout</h1>
            <div className="text-xs text-[#6B6B61] truncate" data-testid="my-payout-who">{user?.display_name} · {KIND_LABEL[user?.role]}</div>
          </div>
          <button onClick={logout} className="ml-auto w-9 h-9 rounded flex items-center justify-center hover:bg-[#F0F0EA]" title="Logout" data-testid="my-payout-logout"><LogOut className="w-4 h-4" /></button>
        </div>
      </header>
      <main className="max-w-5xl mx-auto p-4 space-y-4">
        <RangeBar range={range} setRange={setRange} />
        {err ? <div className="text-sm text-[#C8553D] py-10 text-center" data-testid="my-payout-error">{err}</div> : !st ? (
          <Loader2 className="w-6 h-6 animate-spin text-[#385C4B] mx-auto my-10" />
        ) : (
          <>
            {st.person.agency_names?.length > 0 && <div className="text-xs text-[#6B6B61]" data-testid="my-payout-agencies">Agencies: {st.person.agency_names.join(", ")}</div>}
            <RatesList person={st.person} />
            <Cards s={st} showOpening />
            <div className="flex items-center justify-between">
              <div className="text-xs text-[#6B6B61]">Qty: <b data-testid="my-payout-qty">{st.qty}</b></div>
              <DownloadMenu prefix="my-payout" onExcel={statementExcel} onPdf={statementPdf}
                fetcher={async (r) => (await api.get("/payouts/me", { params: { from_date: r.from, to_date: r.to } })).data} />
            </div>
            <StatementTable st={st} />
          </>
        )}
      </main>
    </div>
  );
}
